import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, exhaustMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as CategoriesActions from './categories.actions';
import { SignupOrgService } from '../../services/signup-org.service';

@Injectable()
export class SignupCategoriesEffects {

  LoadCategories$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(CategoriesActions.LoadCategories),
      exhaustMap(() => {
        return this.signupOrgService.getCategories().pipe(
          map(data => CategoriesActions.LoadCategoriessSucces({ data })),
          catchError(error => of(CategoriesActions.LoadCategoriesFailure({ error }))))
      })
    );
  });

  constructor(
    private actions$: Actions,
    private signupOrgService: SignupOrgService
  ) {}

}
